// src/pages/EliminarDatos.jsx
import { useLanguage } from '../hooks/useLanguage'

export default function EliminarDatos() {
  const { t } = useLanguage()

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f10', color: '#fff', padding: '40px 20px', display: 'flex', justifyContent: 'center' }}>
      <div style={{ maxWidth: 560, width: '100%' }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 8 }}>{t('eliminar_datos_titulo')}</h1>
        <p style={{ color: '#9ca3af', lineHeight: 1.6, marginBottom: 24 }}>
          {t('eliminar_datos_intro')}
        </p>

        <div style={{ background: '#17181c', border: '1px solid #27272a', borderRadius: 16, padding: 20, marginBottom: 16 }}>
          <h2 style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>{t('eliminar_datos_transacciones_titulo')}</h2>
          <p style={{ color: '#9ca3af', fontSize: 13, lineHeight: 1.6 }}>
            {t('eliminar_datos_transacciones_desc')}
          </p>
        </div>

        <div style={{ background: '#17181c', border: '1px solid #27272a', borderRadius: 16, padding: 20, marginBottom: 16 }}>
          <h2 style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>{t('eliminar_datos_foto_titulo')}</h2>
          <p style={{ color: '#9ca3af', fontSize: 13, lineHeight: 1.6 }}>
            {t('eliminar_datos_foto_desc')}
          </p>
        </div>

        <div style={{ background: '#17181c', border: '1px solid #27272a', borderRadius: 16, padding: 20, marginBottom: 24 }}>
          <h2 style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>{t('eliminar_datos_sugerencias_titulo')}</h2>
          <p style={{ color: '#9ca3af', fontSize: 13, lineHeight: 1.6 }}>
            {t('eliminar_datos_sugerencias_desc')}
          </p>
        </div>

        <div style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.25)', borderRadius: 12, padding: 16 }}>
          <p style={{ fontSize: 12, color: '#9ca3af', lineHeight: 1.6 }}>
            <strong style={{ color: '#fff' }}>{t('eliminar_datos_conservados')}</strong> {t('eliminar_datos_conservados_desc')}
            <br /><br />
            {t('eliminar_datos_pregunta_cuenta')}{' '}
            <a href="/eliminar-cuenta" style={{ color: '#3b82f6' }}>{t('eliminar_datos_link_cuenta')}</a>.
          </p>
        </div>
      </div>
    </div>
  )
}